import React from 'react'
import KycOnboardingWizard from '../../components/kyc/KycOnboardingWizard'

/** Full-page patron profile onboarding (Profile Safe). */
export default function ProfileOnboarding() {
  return <KycOnboardingWizard variant="patron" />
}
